import React from "react";

const AboutSection = () => {
  return (
    <section id="about" className="py-10 px-5 md:px-10 pb-0 scroll-mt-24">
      <div className="flex flex-row justify-between items-center">
        <div>
          <p className="uppercase text-[16px] font-[500] text-[#62646C]">
            About
          </p>
          <h2 className="uppercase font-medium text-xl">Hi, I'm Mary</h2>
          <p className="font-medium text-lg md:text-xl text-neutral-300 max-w-5xl leading-relaxed mt-2">
            I'm a frontend-focused software engineer with experience across
            product design and end-to-end development. I turn complex ideas
            into thoughtful products by combining UX judgment, accessible
            frontend engineering and product thinking.
          </p>
        </div>
        {/* <div>
          <button>Know more</button>
        </div> */}
      </div>
      <hr className="my-8 md:my-16 h-[1px] border-neutral-700" />
    </section>
  );
};

export default AboutSection;
